export default {
    meta: {
        title: '鱼你在一起-合同信息',
        url: '/fishtogether/storeassess',
        urlName: '鱼你店铺评估'
    }
};
